import { Uuid } from "types"

export const PriceNomenclatureFiltersCell = ({
    value,
}: {
    value: Array<{ name: string; id: Uuid }>
}) => {
    const valueArray = Array.isArray(value) ? value : [];
    
    return <span>{valueArray.map((el) => el?.name || "").join("; ")}</span>
}
